import { render } from "./SoundWaveForm.vue?vue&type=template&id=c0653c24&scoped=true"
import script from "./SoundWaveForm.vue?vue&type=script&lang=js"
export * from "./SoundWaveForm.vue?vue&type=script&lang=js"

import "./SoundWaveForm.vue?vue&type=style&index=0&id=c0653c24&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0653c24"]])

export default __exports__